"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxReportEnum = void 0;
var TaxReportEnum;
(function (TaxReportEnum) {
    TaxReportEnum["All"] = "all";
    TaxReportEnum["Stocks"] = "stocks";
    TaxReportEnum["Crypto"] = "crypto";
})(TaxReportEnum = exports.TaxReportEnum || (exports.TaxReportEnum = {}));
//# sourceMappingURL=tax-report-enum.js.map